import { Form, Modal, ModalProps } from 'antd';
import moment, { Moment } from 'moment';
import { useRouteMatch } from 'react-router-dom';
import CompanyResourceLimitationPeriodsForm from '../CompanyResourceLimitationPeriodsForm';
import {
  useCreateResourceLimtationPeriod,
  useResourceLimitationPeriodsDetails,
} from '@/core/domain/enterprise/ResourceLimitationPeriods/ResourceLimitationPeriods.hooks';
import { useEffect } from 'react';

interface Props extends ModalProps {
  onCancel?: VoidFunction;
  isView?: boolean;
  resourceLimitationPeriodId?: number;
}

export interface CompanyResourceLimitationPeriodsFormValues {
  description: string;
  resources?: number;
  allResources?: boolean;
  timeRange: [Moment, Moment];
  date: Moment;
}

export default function CompanyResourceLimitationPeriodsModal({
  isView,
  resourceLimitationPeriodId,
  ...modalProps
}: Props) {
  const [form] = Form.useForm<CompanyResourceLimitationPeriodsFormValues>();

  const { companyId } = useRouteMatch<{ companyId: string }>().params;

  const resourceLimitationPeriodDetails = useResourceLimitationPeriodsDetails(
    resourceLimitationPeriodId,
    modalProps.open,
  );

  const createResourceLimitationPeriod = useCreateResourceLimtationPeriod();

  useEffect(() => {
    if (resourceLimitationPeriodDetails.data) {
      const resourceLimitationPeriodsDetailsData =
        resourceLimitationPeriodDetails.data;

      const resources = resourceLimitationPeriodsDetailsData.resources;

      form.setFieldsValue({
        description: resourceLimitationPeriodsDetailsData.description,
        resources: resources === 0 ? undefined : resources,
        allResources: resources === 0,
        timeRange: [
          moment(resourceLimitationPeriodsDetailsData.startAt),
          moment(resourceLimitationPeriodsDetailsData.endAt),
        ],
        date: moment(resourceLimitationPeriodsDetailsData.startAt),
      });
    }
  }, [resourceLimitationPeriodDetails.dataUpdatedAt]);

  const handleOk = async () => {
    const values = await form.validateFields();

    const [startTime, endTime] = values.timeRange;

    const startAt = moment(
      `${values.date.format('YYYY-MM-DD')}T${startTime.format('HH:mm:ss')}`,
    )
      .utc()
      .format();

    const endAt = moment(
      `${values.date.format('YYYY-MM-DD')}T${endTime.format('HH:mm:ss')}`,
    )
      .utc()
      .format();

    await createResourceLimitationPeriod.mutateAsync({
      companyId: Number(companyId),
      description: values.description,
      resources: values.allResources ? 0 : values.resources,
      startAt,
      endAt,
    });

    handleCancel();
  };

  const handleCancel = () => {
    form.resetFields();
    modalProps.onCancel?.();
  };

  return (
    <Modal
      {...modalProps}
      onCancel={handleCancel}
      onOk={handleOk}
      width={900}
      title={isView ? 'Visualizar período' : 'Criar período'}
      okText="Criar"
      destroyOnClose
      okButtonProps={{ style: { display: isView ? 'none' : undefined } }}
      confirmLoading={createResourceLimitationPeriod.isLoading}
    >
      <Form layout="vertical" form={form}>
        <CompanyResourceLimitationPeriodsForm isView={isView} form={form} />
      </Form>
    </Modal>
  );
}
